import { render, staticRenderFns } from "./BBPPModeloRegiones.vue?vue&type=template&id=49e6e880"
import script from "./BBPPModeloRegiones.vue?vue&type=script&lang=js"
export * from "./BBPPModeloRegiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports